import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'

import { DataGrid } from '../../../Components/DataGrid/DataGrid'
import pauseIcon from '../../../imgs/pause-button.png'
import playIcon from '../../../imgs/play.png'
//Icons
import deleteIcon from '../../../imgs/remove.png'
import { deleteRefUser, listAffiliateUsers, updateRef } from '../../../services/affiliates'
import { getCouponByRefUserId } from '../../../services/coupon'
import AffiliateCreate from './AffiliateCreate'
const fieldToCouponType = {
  paymentCoupons: 'Coupon',
  paymentShipments: 'Shipments',
  paymentGiftCards: 'Giftcard',
}
const getTodayDateString = () => {
  const today = new Date()
  return today.toISOString().split('T')[0]
}

export default function AffiliatePage() {
  const [users, setUsers] = useState([])
  const [chosenUser, setChosenUser] = useState({})
  const [showModal, setShowModal] = useState(false)
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [chosenUserCoupons, setChosenUserCoupons] = useState([])
  const [paymentInputs, setPaymentInputs] = useState({
    paymentCoupons: '',
    paymentShipments: '',
    paymentGiftCards: '',
    giftCardDate: getTodayDateString(),
  })
  const [_selectedUsers, setSelectedUsers] = useState([])
  const [loading, setLoading] = useState(false)

  const handleDeleteUser = useCallback(
    async user => {
      const confirm = window.prompt('Enter user ID to confirm deletion')
      if (confirm !== user.refUserId) {
        alert('wrong id')
        return
      }

      try {
        await deleteRefUser(user.refUserId)

        setUsers([...users.filter(u => u.refUserId !== user.refUserId)])
        if (chosenUser.refUserId === user.refUserId) {
          setChosenUser({})
          setShowModal(false)
        }
      } catch (error) {
        console.log('handleDeleteUser - error', error)
      }
    },
    [users, chosenUser.refUserId]
  )

  const getAffiliateData = async () => {
    setLoading(true)
    try {
      const res = await listAffiliateUsers()
      console.log('getAffiliateData - res', res)
      setUsers(res)
    } catch (error) {
      console.log('getAffiliateData - error', error)
      alert('Failed! could not get affiliate users!')
    } finally {
      setLoading(false)
    }
  }

  const updateRefUser = async attr => {
    //validations about input
    if (!paymentInputs[attr]) {
      alert('Please enter a payment amount')
      return
    }

    let paymentsHistory = [...(chosenUser.paymentsHistory || [])]
    let paymentDate = new Date().toISOString()
    const value = parseFloat(paymentInputs[attr]) || 0
    paymentsHistory.push({
      type: fieldToCouponType[attr],
      payment: value.toString(),
      date: attr === 'paymentGiftCards' ? paymentInputs.giftCardDate : paymentDate,
    })

    try {
      await updateRef(chosenUser.refUserId, { paymentsHistory })
      setChosenUser({ ...chosenUser, paymentsHistory })

      // Clear the input field after successful submission
      setPaymentInputs(prev => ({
        ...prev,
        [attr]: '',
        giftCardDate: getTodayDateString(),
      }))
    } catch (error) {
      console.log('updateRefUser - error', error)
      alert(`Failed! \n ${error.response?.data?.msg || 'Unknown error occurred'}`)
    }
  }

  const handleShowModal = user => {
    setChosenUser(user)
    setShowModal(true)
    // Reset payment inputs when opening modal
    setPaymentInputs({
      paymentCoupons: '',
      paymentShipments: '',
      paymentGiftCards: '',
      giftCardDate: getTodayDateString(),
    })
  }

  const createRefUser = () => {
    setShowCreateModal(true)
  }

  const onCreateNewRef = newRef => {
    setUsers([...users, newRef])
  }

  const copyToClipboard = str => {
    navigator.clipboard.writeText(str)
  }
  const refHoldHandler = useCallback(
    async user => {
      const confirm = window.prompt('Enter user ID to confirm Hold / Unhold')
      if (confirm !== user.refUserId) {
        alert('wrong id')
        return
      }

      const newValue = user.isOnHold ? !user.isOnHold : true
      try {
        const res = await updateRef(user.refUserId, { isOnHold: newValue })
        console.log('refHoldHandler - res', res)

        setUsers(users =>
          users.map(u => {
            if (u.refUserId === user.refUserId) {
              return { ...u, isOnHold: newValue }
            }
            return u
          })
        )

        if (chosenUser.refUserId === user.refUserId) {
          setChosenUser(c => ({ ...c, isOnHold: newValue }))
        }
      } catch (error) {
        console.log('refHoldHandler - error', error)
      }
    },
    [chosenUser.refUserId]
  )

  // Column definitions for the affiliate users grid
  const columnDefs = useMemo(
    () => [
      {
        headerName: 'Full Name',
        field: 'refFullName',
        sortable: true,
        filter: true,
        minWidth: 150,
      },
      {
        headerName: 'User ID',
        field: 'refUserId',
        sortable: true,
        filter: true,
        minWidth: 120,
        cellRenderer: params => (
          <OverlayTrigger placement='bottom' overlay={<Tooltip>Click to copy</Tooltip>}>
            <div onClick={() => copyToClipboard(params.value)} style={{ cursor: 'pointer', color: '#007bff' }}>
              {params.value}
            </div>
          </OverlayTrigger>
        ),
      },
      {
        headerName: 'Ref Number',
        field: 'refNum',
        sortable: true,
        filter: true,
        minWidth: 100,
      },
      {
        headerName: 'Revenue',
        field: 'rev',
        sortable: true,
        filter: true,
        minWidth: 100,
        valueFormatter: params => {
          if (params.value !== undefined) {
            return `${parseFloat((parseFloat(params.value) * 100).toFixed(2))}%`
          }
          return ''
        },
      },
      {
        headerName: 'Packages Bought',
        field: 'boughtPackages',
        sortable: true,
        filter: true,
        minWidth: 120,
        valueGetter: ({ data }) => {
          return parseInt(data.boughtPackages)
        },
        type: 'numericColumn',
      },
      {
        headerName: 'Shipment Income',
        field: 'packagesShipmentIncome',
        sortable: true,
        filter: true,
        minWidth: 120,
        valueFormatter: params => {
          if (params.value !== undefined) {
            return `${params.value}₪`
          }
          return ''
        },
      },
      {
        headerName: 'Registered Users',
        field: 'registeredUsers',
        sortable: true,
        filter: true,
        minWidth: 120,
        valueGetter: ({ data }) => {
          return parseInt(data.registeredUsers)
        },
        type: 'numericColumn',
      },
      {
        headerName: 'Payment Coupons',
        field: 'paymentCoupons',
        sortable: true,
        filter: true,
        minWidth: 120,
        valueFormatter: params => {
          const total =
            params.data.paymentsHistory?.filter(p => p.type === 'Coupon').reduce((sum, p) => sum + parseFloat(p.payment), 0) || 0
          return `${total}₪`
        },
      },
      {
        headerName: 'Payment Shipments',
        field: 'paymentShipments',
        sortable: true,
        filter: true,
        minWidth: 120,
        valueFormatter: params => {
          const total =
            params.data.paymentsHistory?.filter(p => p.type === 'Shipments').reduce((sum, p) => sum + parseFloat(p.payment), 0) || 0
          return `${total}₪`
        },
      },
      {
        headerName: 'Payment Giftcards',
        field: 'paymentGiftCards',
        sortable: true,
        filter: true,
        minWidth: 120,
        valueFormatter: params => {
          const total =
            params.data.paymentsHistory?.filter(p => p.type === 'Giftcard').reduce((sum, p) => sum + parseFloat(p.payment), 0) || 0
          return `${total}₪`
        },
      },
      {
        headerName: 'Status',
        field: 'isOnHold',
        sortable: true,
        filter: true,
        minWidth: 100,
        valueFormatter: params => {
          return params.value ? 'On Hold' : 'Active'
        },
        cellStyle: params => ({
          color: params.value ? '#dc3545' : '#28a745',
          fontWeight: 'bold',
        }),
      },
      {
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        filter: false,
        minWidth: 200,
        cellRenderer: params => (
          <div className='d-flex gap-2'>
            <Button size='sm' onClick={() => handleShowModal(params.data)} className='action-btn'>
              Pay / Edit
            </Button>
          </div>
        ),
      },
    ],
    []
  )

  useEffect(() => {
    getAffiliateData()
  }, [])

  const fetchUserCoupons = useCallback(async () => {
    try {
      const userCoupons = await getCouponByRefUserId(chosenUser.refUserId)
      // console.log("fetchUserCoupons - userCoupons", userCoupons)
      setChosenUserCoupons(userCoupons)
    } catch (_error) {
      // console.log("fetchUserCoupons - error", error)
    }
  }, [chosenUser.refUserId])

  useEffect(() => {
    if (chosenUser.refUserId) {
      fetchUserCoupons()
    }
  }, [chosenUser.refUserId, fetchUserCoupons])

  const handlePaymentInputChange = e => {
    const { name, value } = e.target
    setPaymentInputs(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  // Handle selection change
  const handleSelectionChanged = useCallback(event => {
    const selectedRows = event.api.getSelectedRows()
    setSelectedUsers(selectedRows)
  }, [])
  return (
    <section className='affiliate-comp'>
      <h1>AffiliatePage</h1>

      <div className='ac-header'>
        <Button onClick={() => createRefUser()}> + Create </Button>
      </div>

      <DataGrid
        rowData={users}
        columnDefs={columnDefs}
        onSelectionChanged={handleSelectionChanged}
        enableSorting={true}
        rowHeight={50}
        enableFiltering={true}
        entityName='affiliate-users'
        className='affiliate-data-grid'
        loading={loading}
        defaultColDef={{
          sortable: true,
          filter: true,
          resizable: true,
          minWidth: 100,
        }}
      />

      <Modal size='lg' show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <h2 style={{ width: '100%', textAlign: 'center' }}>{chosenUser.refFullName}</h2>
        </Modal.Header>
        <Modal.Body>
          <div className='ac-modal-body' style={{ backgroundColor: chosenUser.isOnHold ? '#b1b1b1' : '' }}>
            <div className='ac-modal-field'>
              <div>
                <div> Add Payment For Coupons:</div>
                <input type='number' name='paymentCoupons' value={paymentInputs.paymentCoupons} onChange={handlePaymentInputChange} />
              </div>
              <Button onClick={() => updateRefUser('paymentCoupons')}>Add</Button>
            </div>

            <div className='ac-modal-field'>
              <div>
                <div> Add Payment For Shipments: </div>
                <input type='number' name='paymentShipments' value={paymentInputs.paymentShipments} onChange={handlePaymentInputChange} />
              </div>
              <Button onClick={() => updateRefUser('paymentShipments')}>Add</Button>
            </div>

            <div className='ac-modal-field'>
              <div>
                <div> Add Giftcard Payments: </div>
                <input type='number' name='paymentGiftCards' value={paymentInputs.paymentGiftCards} onChange={handlePaymentInputChange} />
                <div className='ac-giftcard-date-row'>
                  <input
                    type='date'
                    id='giftCardDate'
                    name='giftCardDate'
                    value={paymentInputs.giftCardDate}
                    onChange={handlePaymentInputChange}
                  />
                </div>
              </div>
              <Button onClick={() => updateRefUser('paymentGiftCards')}>Add</Button>
            </div>

            <div className='ac-modal-history'>
              <h4>Payments History</h4>
              <table>
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Payment</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {chosenUser.paymentsHistory?.map((paymentObj, idx) => {
                    return (
                      <tr key={idx}>
                        <td>{paymentObj.type}</td>
                        <td>{paymentObj.payment}</td>
                        <td>{paymentObj.date.split('T')[0]}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
            <div className='ac-modal-coupons'>
              <h4>Active Coupons</h4>
              <table>
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Expired</th>
                    <th>Times used</th>
                    <th>Final payments</th>
                  </tr>
                </thead>
                <tbody>
                  {chosenUserCoupons?.map((coupon, idx) => (
                    <tr key={idx}>
                      <td>{coupon.code}</td>
                      <td>{coupon.expiredAt.split('T')[0]}</td>
                      <td>{coupon.timesUsed}</td>
                      <td>{coupon.totalFinalPayments}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className='ac-actions-cont'>
              <img src={deleteIcon} onClick={() => handleDeleteUser(chosenUser)} />
              {chosenUser.isOnHold ? (
                <img src={playIcon} onClick={() => refHoldHandler(chosenUser)} />
              ) : (
                <img src={pauseIcon} onClick={() => refHoldHandler(chosenUser)} />
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {showCreateModal && <AffiliateCreate onHide={() => setShowCreateModal(false)} onCreateNewRef={onCreateNewRef} />}
    </section>
  )
}
